// shared/constants.js
// Constants and explanations for competitive analysis
// Extracted from CompetitiveAnalysisView.jsx for better maintainability

// Chart colors for consistent styling
export const COLORS = ['#3B82F6', '#10B981', '#6366F1', '#F59E0B', '#EF4444'];

// Market position explanations
export const POSITION_EXPLANATIONS = {
    leader: "Market leaders dominate with high revenue and mindshare. Consider strategic differentiation rather than direct competition.",
    challenger: "Challengers have established presence but aren't dominant. Look for ways to innovate beyond their current offerings.",
    mid_market: "Mid-market players serve specific audiences. Consider how you could better serve these niches or innovate beyond them.",
    unknown: "Insufficient data to determine market position. Further research recommended."
};

// Trend explanations
export const TREND_EXPLANATIONS = {
    rising: "The market position of these competitors is improving over time, indicating successful strategies you might study.",
    stable: "The market position is holding steady without significant growth or decline.",
    declining: "The market position is weakening, which may indicate outdated strategies or market saturation."
};

// Competitive strength explanations
export const STRENGTH_EXPLANATIONS = {
    high: "Competitors demonstrate significant market power through brand recognition, resources, or unique advantages.",
    medium: "Competitors have moderate competitive advantages but also some vulnerabilities.",
    low: "Competitors show limited competitive advantages, suggesting opportunities for new market entrants."
};

/**
 * Utility function for formatting revenue values
 * @param {number} value - Revenue value to format
 * @returns {string} Formatted revenue string
 */
export const formatRevenue = (value) => {
    if (!value) return '$0';
    if (value >= 1000000000) return `${(value / 1000000000).toFixed(1)}B`;
    if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
    return `${(value / 1000).toFixed(1)}K`;
};
